const csMixin = {
  methods: {
    parsedBr (html) {
      return html.replaceAll(/(\n|\r\n)/g, '<br/>')
    },
    parsedHtml (html) {
      const parser = new DOMParser()
      const elem = parser.parseFromString(html, 'text/html')

      return elem.body.innerText
    },
    goBack () {
      this.$router.back()
    },
    isExist (ele) {
      return !(ele === null || ele === undefined || ele === '' || ele === 'undefined')
    },
    isNotExist (ele) {
      return (ele === null || ele === undefined || ele === '' || ele === 'undefined')
    },
    openToast (message) {
      this.$notify({
        message,
        position: 'bottom-right',
        showClose: false,
        duration: 2000,
        onClick: () => { this.$notify.closeAll() }
      })
    },
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    goExtLink (type, query) {
      let url = ''
      switch (type) {
        case 'iqry': url = 'cs-csl-SCR_CSL_0001'
          break
        case 'return': url = 'or-orb-SCR_ORB_0017'
          break
        case 'exchange': url = 'or-orb-SCR_ORB_0017'
          break
        case 'orList': url = 'or-orb-SCR_ORB_0001'
          break
        default : url = ''
      }
      this.$router.push({ name: url, query })
    }

  }
}

export {
  csMixin
}
